import _ from 'lodash';

const getJobValuesToSave = (data) => {
  /* eslint-disable no-param-reassign */
  return _.reduce(
    data,
    (result, val, key) => {
      result[key] = val;
      return result;
    },
    {}
  );
  /* eslint-enable no-param-reassign */
};

export default getJobValuesToSave;
